module.exports = __webpack_public_path__ + "img/18.e95445f3.png";